import { render, staticRenderFns } from "./blog-filter-app.vue?vue&type=template&id=ed38a7a4&"
import script from "./blog-filter-app.vue?vue&type=script&lang=js&"
export * from "./blog-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports